import { useEffect, useRef } from 'react';
import NotificationHandler from '../../../utils/NotificationHandler';
import { enumUtil } from '../../../utils/Enum';
import useIndexDatabase from '../../../customhooks/useIndexDatabase';
import store from '../../../store';

const useHandleOpenNewBrowserTab = () => {
    const openWindowsRef = useRef([]); // Persistent across renders
    
    const { db, put, remove } = useIndexDatabase('SHCTDatabase', 1, 'ChildWindow');

    const handleOpenNewBrowserTab = (content) => {
        // Block child → child
        if (!content || window?.name?.startsWith('Child_Tab ')) {
            NotificationHandler('Child windows cannot be opened from another child window', enumUtil.enumtoaster.warning)
            return;
        }

        // Save content for child window
        if (db) {
            put({ name: 'browserNewTabContent', value: JSON.stringify(content) });
        }

        // Capture redux
        CaptureCurrentReduxState();

        // Calculate size + position
        let url = window.location.href.replace(/#$/, "");

        const width = Math.floor(window.screen.width * 0.83);
        const height = Math.floor(window.screen.height * 0.76);

        const left = (window.screenLeft || window.screenX) + (window.innerWidth - width);
        const top = (window.screenTop || window.screenY) + (window.innerHeight - height);

        // Generate unique name
        const childNumber = getNextChildNumber();
        const windowName = `Child_Tab ${childNumber}`;

        const newWindow = window.open(
            url,
            windowName,
            `width=${width},height=${height},left=${left},top=${top}`
        );

        openWindowsRef.current.push(newWindow);

        // Auto-clean when closed
        const intervalId = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(intervalId);
                remove('browserNewTabContent');
            }
        }, 200);
    };

    // Close all children on parent unload
    useEffect(() => {
        const closeAll = () => {
            openWindowsRef.current.forEach(w => {
                if (w && !w.closed) w.close();
            });
        };

        window.addEventListener('beforeunload', closeAll);
        return () => window.removeEventListener('beforeunload', closeAll);
    }, []);

    return handleOpenNewBrowserTab;
};

const CaptureCurrentReduxState = () => {
    try {
        const reduxObj = store.getState();
        let valuesToExtractObj = {
            GeneralDropDownsReducer: {},
            CodesDropDownReducer: {},
            RolesandRightsReducer: [],
            PaymentDropdownReducer: {},
            SettingsReducer: { DefaultPageView: "Grid View", PaginationDefaultRows: "10" },
            IsUserProvider: false
        };

        const extractValues = (reduxObj, Obj) => {
            return Object.keys(Obj).reduce((result, key) => {
                result[key] = reduxObj.hasOwnProperty(key) ? reduxObj[key] : Obj[key];
                return result;
            }, {});
        };

        const objToStore = extractValues(reduxObj, valuesToExtractObj);
        localStorage.setItem('reduxState', JSON.stringify(objToStore));
    } catch (err) { }
};

const getNextChildNumber = () => {
    const last = parseInt(localStorage.getItem("Child_Tab_Count") || "0", 10);
    const next = last + 1;
    localStorage.setItem("Child_Tab_Count", next);
    return next;
};


export default useHandleOpenNewBrowserTab;
